import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import uploadImg from "../../assets/images/uploadicon.svg";
import CicleCloseIcon from "../../assets/images/CircleCloseIcon.svg";
import "./style.css";
import Toaster from "../Toaster/Toster";
import { uploadShareFile } from "../../services/auth.api";

interface FileUploadModalProps {
  open: boolean;
  onClose: () => void;
  onFileChange: (files: File[]) => void;
}

const FileUploadModal: React.FC<FileUploadModalProps> = ({
  open,
  onClose,
  onFileChange,
}) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);
  const [fileList, setFileList] = useState<File[]>([]);
  const [errorMessages, setErrorMessages] = useState<string[]>([]);
  const [show, setShow] = useState(false);

  const onDragEnter = () => wrapperRef.current?.classList.add("dragover");
  const onDragLeave = () => wrapperRef.current?.classList.remove("dragover");
  const onDrop = () => wrapperRef.current?.classList.remove("dragover");

  const handleFileUpload = async (file: File) => {
    try {
      const response = await uploadShareFile(file);
      console.log("File uploaded successfully:", response);

      setFileList((prevList) => [...prevList, file]);
      onFileChange([...fileList, file]);
      setShow(true);
    } catch (error) {
      console.error("Error uploading file:", error);
      setErrorMessages((prev) => [
        ...prev,
        `Error uploading file: ${file.name}`,
      ]);
    }
  };

  const onFileDrop = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newFiles = Array.from(e.target.files || []);
    const allowedExtensions = ["pdf", "doc", "docx", "xls", "xlsx","txt"];

    const validFiles = newFiles.filter((file) => {
      const fileExtension = file.name.split(".").pop()?.toLowerCase();
      return fileExtension ? allowedExtensions.includes(fileExtension) : false;
    });

    const invalidFiles = newFiles.filter((file) => !validFiles.includes(file));
    if (invalidFiles.length > 0) {
      const invalidMessages = invalidFiles.map(
        (file) => `Invalid file type: ${file.name}`
      );
      setErrorMessages((prev) => [...prev, ...invalidMessages]);
    } else {
      setErrorMessages([]);
    }

    const updatedList = [...fileList, ...validFiles];
    setFileList(updatedList);
    onFileChange(updatedList);

    validFiles.forEach((file) => handleFileUpload(file));
  };

  return (
    <>
      <Modal show={open} onHide={onClose} centered className="fileUpload-modal">
        <Modal.Header className="border-0 d-flex justify-content-between align-items-center">
          <Modal.Title id="file-upload-modal" className="fileUpload-title">
            Documents Upload
          </Modal.Title>
          <span style={{ cursor: "pointer" }} onClick={onClose}>
            <img src={CicleCloseIcon} alt="Close" />
          </span>
        </Modal.Header>
        <Modal.Body>
          <div
            ref={wrapperRef}
            className="p-4 text-center mb-4 upload-document-input"
            onDragEnter={onDragEnter}
            onDragLeave={onDragLeave}
            onDrop={onDrop}
          >
            <div className="d-flex align-items-center justify-content-center">
              <img
                src={uploadImg}
                alt="Upload"
                style={{ marginRight: "10px" }}
              />
              <div className="text-start">
                <h2 className="upload-document-label m-0">
                  Select documents to upload or drag & drop
                </h2>
                <span className="upload-document-sublabel text-start">
                  Supported file types: pdf, doc, docx, xls, xlsx
                </span>
              </div>
            </div>
            <input
              type="file"
              onChange={onFileDrop}
              multiple
              className="fileUpload-input"
            />
          </div>
          {errorMessages.length > 0 && (
            <div className="text-danger">
              {errorMessages.map((msg, index) => (
                <p key={index} className="m-0">
                  {msg}
                </p>
              ))}
            </div>
          )}
        </Modal.Body>
      </Modal>
      <Toaster
      type="success"
        show={show}
        setShow={setShow}
        message={"File Uploaded successfully"}
      />
    </>
  );
};

export default FileUploadModal;
